import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_GALLERIES = "galleries";
const BASE_URL = "/api/galleries";

const GalleryQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const GALLERY_EMPTY = {title: "", description: "",posistion:"",albums:[], fileId:""};

export function useGallerys() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_GALLERIES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...GalleryQueryConfig
    });
    return {...result, galleries: result.data};
}


export function useGallery(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_GALLERIES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...GalleryQueryConfig
    });
    return {...result, gallery: result.data};
}

export function useGalleryMutations() {
    async function createFunction(gallery) {
        if (!gallery) return;
        return await fetchPOST(BASE_URL, gallery, false);
    }

    async function editFunction(gallery) {
        if (!gallery) return;
        return  await fetchPUT(`${BASE_URL}/${gallery.id}`, gallery);
    }

    async function editAddNewFiles(gallery) {
        if (!gallery) return;
        return await fetchPUT(`${BASE_URL}/${gallery.id}/files`, gallery.fileId);
    }
    async function editAddAlbums(gallery) {
        if (!gallery) return;
        return await fetchPUT(`${BASE_URL}/${gallery.id}/albums`, gallery.albums);
    }

    async function deleteFunction(gallery) {
        return await fetchDELETE(`${BASE_URL}/${gallery.id}`)
    }

    return {
        createGallery: useMyMutation(createFunction, REACT_QUERY_ID_GALLERIES, gallery => `Gallery ${gallery.title} created`),
        editGallery: useMyMutation(editFunction, REACT_QUERY_ID_GALLERIES, gallery => `Gallery ${gallery.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_GALLERIES, gallery => `Gallery ${gallery.title} modified`),
        editAddAlbums:useMyMutation(editAddAlbums,REACT_QUERY_ID_GALLERIES, gallery => `Gallery ${gallery.title} modified`),
        deleteGallery: useMyMutation(deleteFunction, REACT_QUERY_ID_GALLERIES, gallery => `Gallery ${gallery.title} deleted.`)
    };

}